import React from "react";
import { Link } from "react-router-dom";

import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { ATHLETE_BROWSE } from "../../Utils/Constants";
import "./NotFound.css";

/**
 * There was no 404 route at all. Worse, `/:teamId` was a single-segment
 * catch-all, so `nil-collab.com/typo` rendered a broken dashboard that fired a
 * failing API call instead of saying "not found".
 */
export default function NotFound() {
  return (
    <div>
      <Header />
      <div className="notfound">
        <div className="notfound-code">404</div>
        <h1>We couldn&rsquo;t find that page</h1>
        <p>
          The link may be out of date, or the athlete may no longer be listed on
          a roster.
        </p>
        <div className="notfound-actions">
          <Link className="notfound-primary" to={ATHLETE_BROWSE}>
            Browse athletes
          </Link>
          <Link className="notfound-secondary" to="/">
            Go home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
